<template>
  <v-row>
    <v-col v-for="fundingSource in fundingSources" :key="fundingSource.id">
      <v-card class="fill-height" :loading="loading">
        <v-card-title class="justify-center">
          External Account Balance
        </v-card-title>
        <v-card-text class="text-center" v-if="!loading && fundingSource.externalAccount">
          <div class="display-1">
            {{
              fundingSource.externalAccount.externalBalance
                ? fundingSource.externalAccount.externalBalance
                : 0 | toNumber(2, selectedProgram)
            }}
            {{
              fundingSource.externalAccount.externalBalanceCurrency
                ? fundingSource.externalAccount.externalBalanceCurrency
                : ""
            }}
          </div>
          <div v-if="fundingSource.externalAccount.lastSyncDate">
            Last Sync:
            {{
              fundingSource.externalAccount.lastSyncDate
                ? moment(fundingSource.externalAccount.lastSyncDate).format("MM/DD/YYYY hh:mm a")
                : ""
            }}
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "ExternalAccountBalanceWidget",
  props: {
    showActions: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      fundingSources: []
    };
  },

  watch: {
    selectedFiscalYear() {
      this.fetchExternalAccountBalance();
    },
    selectedProgram() {
      this.fetchExternalAccountBalance();
    }
  },
  computed: {
    ...mapGetters(["selectedProgram", "selectedFiscalYear"])
  },
  mounted() {
    if (!this.fundingSources || this.fundingSources.length === 0) {
      this.fetchExternalAccountBalance();
    }
  },
  methods: {
    moment,
    fetchExternalAccountBalance() {
      this.loading = true;
      let searchForm = { isAssignedToAwardVehicleInProgram: true };

      let isCurrentFiscalYear = this.selectedFiscalYear.fiscalYear == moment().year();
      if (!isCurrentFiscalYear) {
        searchForm.effectiveFrom = this.selectedFiscalYear.fiscalYearStart;
        searchForm.effectiveTo = this.selectedFiscalYear.fiscalYearEnd;
      }
      this.$api
        .post("/api/fundingSources/search", searchForm)
        .then(({ data }) => {
          this.fundingSources = data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
